import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@siu/shared';
import { AvisoUsuarioComponent } from 'src/app/modules/01-home/pages/index/components/aviso-usuario/aviso-usuario.component';
import { GuiaUsuarioComponent } from 'src/app/modules/01-home/pages/index/components/guia-usuario/guia-usuario/guia-usuario.component';
import { MensajeDisponibilidadComponent } from '../mensaje-disponibilidad/mensaje-disponibilidad.component';
import { IndexTupaComponent } from './container/index-tupa.component';
import { IndexTupaRoutingModule } from './index-tupa-routing.module';
@NgModule({
  declarations: [IndexTupaComponent, GuiaUsuarioComponent, MensajeDisponibilidadComponent, AvisoUsuarioComponent],
  imports: [
    CommonModule,
    IndexTupaRoutingModule,
    SharedModule
  ],
  entryComponents: [GuiaUsuarioComponent, MensajeDisponibilidadComponent, AvisoUsuarioComponent]
})
export class IndexTupaModule { }
